/* ============================================================================
   NAS ME Pro - Technical Specifications table
   Drives the custom horizontal scrollbar under the spec table:
     - hidden entirely when the table fits its container
     - thumb width / offset track the scroll position
     - thumb is draggable, track is click-to-jump
   The first column is pinned with CSS (position: sticky), not JS.
   ========================================================================= */

(function () {
    'use strict';

    var VIEWPORT_SELECTOR = '[data-nas-st-viewport]';
    var MIN_THUMB_WIDTH = 40;

    function initViewport(viewport) {
        if (!viewport || viewport.getAttribute('data-nas-st-ready') === 'true') {
            return;
        }

        var scroller = viewport.querySelector('[data-nas-st-scroll]');
        var track = viewport.querySelector('[data-nas-st-scrollbar]');
        var thumb = viewport.querySelector('[data-nas-st-thumb]');

        if (!scroller || !track || !thumb) {
            return;
        }

        viewport.setAttribute('data-nas-st-ready', 'true');

        var dragging = false;
        var dragStartX = 0;
        var dragStartScroll = 0;
        var dragRatio = 1;

        function maxScroll() {
            return scroller.scrollWidth - scroller.clientWidth;
        }

        function render() {
            var max = maxScroll();

            if (max <= 1) {
                track.hidden = true;
                return;
            }

            track.hidden = false;

            var trackWidth = track.clientWidth;
            var thumbWidth = Math.max(
                MIN_THUMB_WIDTH,
                Math.round((trackWidth * scroller.clientWidth) / scroller.scrollWidth)
            );
            var travel = Math.max(0, trackWidth - thumbWidth);
            var offset = travel * (scroller.scrollLeft / max);

            thumb.style.width = thumbWidth + 'px';
            thumb.style.transform = 'translateX(' + offset + 'px)';
        }

        function pointerX(event) {
            return event.touches && event.touches.length ? event.touches[0].clientX : event.clientX;
        }

        function onDragStart(event) {
            dragging = true;
            dragStartX = pointerX(event);
            dragStartScroll = scroller.scrollLeft;

            var travel = Math.max(1, track.clientWidth - thumb.offsetWidth);
            dragRatio = maxScroll() / travel;

            thumb.classList.add('is-dragging');
            document.body.style.userSelect = 'none';
        }

        function onDragMove(event) {
            if (!dragging) {
                return;
            }
            scroller.scrollLeft = dragStartScroll + (pointerX(event) - dragStartX) * dragRatio;
            if (event.cancelable) {
                event.preventDefault();
            }
        }

        function onDragEnd() {
            if (!dragging) {
                return;
            }
            dragging = false;
            thumb.classList.remove('is-dragging');
            document.body.style.userSelect = '';
        }

        function onTrackClick(event) {
            if (event.target === thumb || dragging) {
                return;
            }
            var bounds = track.getBoundingClientRect();
            var progress = (event.clientX - bounds.left) / bounds.width;
            scroller.scrollTo({
                left: maxScroll() * Math.min(1, Math.max(0, progress)),
                behavior: 'smooth'
            });
        }

        scroller.addEventListener('scroll', render, { passive: true });
        window.addEventListener('resize', render);
        window.addEventListener('load', render);

        thumb.addEventListener('mousedown', onDragStart);
        thumb.addEventListener('touchstart', onDragStart, { passive: true });
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('touchmove', onDragMove, { passive: false });
        document.addEventListener('mouseup', onDragEnd);
        document.addEventListener('touchend', onDragEnd);
        document.addEventListener('touchcancel', onDragEnd);
        track.addEventListener('click', onTrackClick);

        if (typeof ResizeObserver === 'function') {
            new ResizeObserver(render).observe(scroller);
        }

        render();
    }

    function initAll(root) {
        var scope = root && root.querySelectorAll ? root : document;
        var nodes = scope.querySelectorAll(VIEWPORT_SELECTOR);

        for (var i = 0; i < nodes.length; i++) {
            initViewport(nodes[i]);
        }

        // shopify:section:load hands us the section wrapper itself
        if (root && root.matches && root.matches(VIEWPORT_SELECTOR)) {
            initViewport(root);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initAll();
        });
    } else {
        initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
        initAll(event.target);
    });
})();
